import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import ShowCase from '../../screens/ShowCase';
import Promo from '../../screens/Promo';

const LoginRouter = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/promo`}>
        <Promo />
      </Route>
      <Route exact path={`${path}/`}>
        <ShowCase />
      </Route>
    </Switch>
  );
};

export default LoginRouter;
